import * as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Andres_Francisco_Garcia from '../../media/Brothers/Headshots/Xi/Andres_Francisco_Garcia.jpg';
import Aric_Peng from '../../media/Brothers/Headshots/Xi/Aric_Peng.jpg';
import Andrew_Zhang from '../../media/Brothers/Headshots/Xi/Andrew_Zhang.jpg';
import Danial_Arab from '../../media/Brothers/Headshots/Xi/Danial_Arab.jpg';
import Emika_Hammond from '../../media/Brothers/Headshots/Xi/Emika_Hammond.jpeg';
import Jacob_Char_Chin from '../../media/Brothers/Headshots/Xi/Jacob_Char_Chin.jpg';
import James_Decker from '../../media/Brothers/Headshots/Xi/James_Decker.jpg';
import Maiko_Lum from '../../media/Brothers/Headshots/Xi/Maiko_Lum.jpg';
import Nuo_Lin from '../../media/Brothers/Headshots/Xi/Nuo_Lin.jpg';
import Samuel_Haley from '../../media/Brothers/Headshots/Xi/Samuel_Haley.jpg';
import Trevor_Tatsuo_Chan from '../../media/Brothers/Headshots/Xi/Trevor_Tatsuo_Chan.jpg';
import Vansh_Patel from '../../media/Brothers/Headshots/Xi/Vansh_Patel.jpg';


import Stack from '@mui/material/Stack';

//Xi class


const Xi = () => {
  const xiClass = [
    {broname: "Andres Francisco Garcia", src: Andres_Francisco_Garcia, alt: "Andres Garcia", majorGrad: "Computer Engineering '24"},
    {broname: "Aric Peng", src: Aric_Peng, alt: "Aric Peng", majorGrad: "Mechanical Engineering '25"},
    {broname: "Andrew Zhang", src: Andrew_Zhang, alt: "Andrew Zhang", majorGrad: "Mechanical Engineering '25"},
    {broname: "Danial Arab", src: Danial_Arab, alt: "Danial Arab", majorGrad: "Mechanical Engineering '25"},
    {broname: "Emika Hammond", src: Emika_Hammond, alt: "Emika Hammond", majorGrad: "Computer Engineering '25"},
    {broname: "Jacob Char Chin", src: Jacob_Char_Chin, alt: "Jacob Chin", majorGrad: "Computer / Biomedical Engineering '25"},
    {broname: "James Decker", src: James_Decker, alt: "James Decker", majorGrad: "Biomedical Engineering '25"},
    {broname: "Maiko Lum", src: Maiko_Lum, alt: "Maiko Lum", majorGrad: "Biomedical Engineering '25"},
    {broname: "Nuo Lin", src: Nuo_Lin, alt: "Nuo Lin", majorGrad: "Mechanical Engineering '24"},
    {broname: "Samuel Haley", src: Samuel_Haley, alt: "Samuel Haley", majorGrad: "Mechanical Engineering '24"},
    {broname: "Trevor Tatsuo Chan", src: Trevor_Tatsuo_Chan, alt: "Trevor Chan", majorGrad: "Computer Engineering '24"},
    {broname: "Vansh Patel", src: Vansh_Patel, alt: "Vansh Patel", majorGrad: "Biomedical Engineering '25"},
  ];
  return (
    <div className = "Classes">
      {xiClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default Xi;